import './styles.scss'

import React, { useState } from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

const SubscribeForm = ({ subscribeUrl }) => {
  const [email, setEmail] = useState('')
  return (
    <form action={subscribeUrl} method='post'>
      <input
        type='email'
        name='email'
        value={email}
        onChange={e => setEmail(e.target.value)}
        className='input-text subscribe-form-email-input'
        placeholder={I18n.t('layouts.footer.email_placeholder')}
      />
      <input type='submit' className='button subscribe-form-button' value={I18n.t('layouts.footer.email_join')} />
    </form>
  )
}

SubscribeForm.propTypes = {
  subscribeUrl: PropTypes.string
}

export default SubscribeForm
